export default "__VITE_ASSET__eCilaycU__"